import axios from 'axios'
import { EXCLUIR_AGENCIAS } from '../types'
import { SLOW_REQUEST_CONFIG } from '../../util/loadingUtil'
import { URL } from '../../util/ambienteActions';

export default function excluirVeiculo (idAgencia, idEmpresa) {
  const url = `${URL}/agencia/${idAgencia}/empresa/${idEmpresa}/excluir`;

  return dispatch => axios.post(url, null, SLOW_REQUEST_CONFIG).then(
      response => dispatch({
        type: EXCLUIR_AGENCIAS,
        payload: response
      })
  );
}
